import account from "./DE/account.json"
import aiDiagnose from "./DE/aiDiagnose.json"
import allCarManage from "./DE/allCarManage.json"
import base from "./DE/base.json"
import bookingManagement from "./DE/bookingManagement.json"
import common from "./DE/common.json"
import contractManagement from "./DE/contractManagement.json"
import dataManage from "./DE/dataManage.json"
import home from "./DE/home.json"
import homeMap from "./DE/homeMap.json"
import moveCarManage from "./DE/moveCarManage.json"
import orderManage from "./DE/orderManage.json"
import ordersManage from "./DE/ordersManage.json"
import index from "./DE/index.json"
import menu from "./DE/menu.json"
import newCommon from "./DE/newCommon.json"
import paper from "./DE/paper.json"
import shopOrder from "./DE/shopOrder.json"
import statistics from "./DE/statistics.json"
import statisticsIndex from "./DE/statisticsIndex.json"
import storeManagement from "./DE/storeManagement.json"
import tdms from "./DE/tdms.json"
import teamManage from "./DE/teamManage.json"
import stock from "./DE/stock.json"
import settings from "./DE/settings.json"
import purchase from "./DE/purchase.json"
import shopping from "./DE/shopping.json"
import sale from "./DE/sale.json"
import quickBilling from "./DE/quickBilling.json"
import components from "./DE/components.json"
import erpcomponents from "./DE/erpcomponents.json"
import orgManage from "./DE/orgManage.json"
import customerManage from "./DE/customerManage.json"
import dataDictionaries from "./DE/dataDictionaries.json"
import login from "./DE/Login.json"
import logs from "./DE/logs.json"
import permission from "./DE/permission.json"
import utils from "./DE/utils.json"




const deDE = {
  translation: {
    utils,
    permission,
    logs,
    login,
    common,
    index,
    menu,
    aiDiagnose,
    bookingManagement,
    allCarManage,
    contractManagement,
    dataManage,
    home,
    homeMap,
    moveCarManage,
    orderManage,
    ordersManage,
    teamManage,
    tdms,
    storeManagement,
    statisticsIndex,
    statistics,
    shopOrder,
    account,
    base,
    paper,
    newCommon,
    stock,
    settings,
    purchase,
    shopping,
    sale,
    quickBilling,
    components,
    erpcomponents,
    orgManage,
    customerManage,
    dataDictionaries
  }
};
export default deDE;
